import apiClient from "./axiosInstance"

export const TAstatistics = async () => {
  const response = await apiClient.get("/admin/statistics/statisticsnum", {
    timeout: 60000,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAtcNoControl = async (
  tcNo: string,
  firstName: string,
  lastName: string,
  birthYear: string,
) => {
  const response = await apiClient.post(
    `/admin/statistics/tcnocontrol?tcNo=${tcNo}&firstName=${firstName}&lastName=${lastName}&birthYear=${birthYear}`,
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TargetPopularBrands = async (
  page: number,
  perPage: number,
  sortBy?: string,
  sortOrder?: boolean,
) => {
  const response = await apiClient.get(
    `/admin/brand/getpopularbrands?perPage=${perPage}&page=${page}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Update failed")
  }
}

export const TAwpMessages = async (
  page: number,
  perPage: number,
  sortBy?: string,
  sortOrder?: boolean,
) => {
  const response = await apiClient.get(
    `/admin/statistics/wp-messages?page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAuserPayments = async (
  query: Record<string, string>,
  page: number,
  perPage: number,
  sortBy?: string,
  sortOrder?: boolean,
) => {
  const queryString = new URLSearchParams(query).toString()
  const sortByParam = sortBy ? `&sortBy=${sortBy}` : ""
  const sortOrderParam = sortOrder !== undefined ? `&sortOrder=${sortOrder}` : ""

  const response = await apiClient.get(
    `/admin/statistics/user-payments?page=${page}&perPage=${perPage}&${queryString}${sortByParam}${sortOrderParam}`,
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAchangePayment = async (payment_id: string, status: string) => {
  const response = await apiClient.post(
    "/admin/statistics/change-payment",
    { payment_id, status },
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAupdatePaymentNote = async (payment_id: string, note: string) => {
  const response = await apiClient.post(
    `/admin/statistics/user-payments/${payment_id}?note=${encodeURIComponent(note)}`,
    {},
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAwpChat = async (page: number, perPage: number, from: string) => {
  const response = await apiClient.get(
    `/admin/statistics/wp-chat?page=${page}&perPage=${perPage}&from=${encodeURIComponent(from)}`,
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAwpSendMessage = async (phoneNumber: string, message: string) => {
  const response = await apiClient.post(
    "/admin/statistics/send-message",
    {
      phoneNumber,
      message,
    },
    {
      timeout: 60000,
    },
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Statistics not found")
  }
}

export const TAgetCountries = async (search = "") => {
  const response = await apiClient.get(
    `/admin/statistics/countries?search=${encodeURIComponent(search)}`,
  )

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Countries not found")
  }
}
